import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ToastMachineService } from './toast-machine.service';

@Injectable({
  providedIn: 'root',
})
export class AwsService {
  hotelId = localStorage.getItem('hotelId') || '0';
  constructor(private http: HttpClient, private toaster: ToastMachineService) {}

  uploadRequestPhoto(
    image: string,
    id: number,
    taskImg?: boolean
  ): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const fileBits = this.dataURItoBlob(image);
      const imageFile = new File(
        [fileBits],
        id + (taskImg ? '_1' : '') + '.jpeg',
        { type: 'image/jpeg' }
      );

      const postImage = new FormData();
      postImage.append('file', imageFile, id.toString() + '.jpeg');

      this.http
        .post(
          environment.apiURL +
            '/uploaddocument?&bucketname=b1development&directory=icibotV2/issues/' +
            this.hotelId +
            '/' +
            id +
            '/images',
          postImage
        )
        .subscribe({
          next: () => {
            resolve(true);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }
  // "/listbucketitems?bucketname=b1development&directory=icibotV2/776/assets/i18/"
  getListBucketItems(bucketName: string, directory: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(
          environment.apiURL +
            '/listbucketitems?bucketname=' +
            bucketName +
            '&directory=' +
            directory
        )
        .subscribe({
          next: (data: any) => {
            resolve(data);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  getFileContent(url: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.get(url).subscribe({
        next: (data: any) => {
          resolve(data);
        },
        error: (err) => {
          const error =
            err.error && err.error.message ? err.error.message : err.message;
          this.toaster.toastMachine(error, 'danger', 3000);
          reject(err);
        },
      });
    });
  }

  uploadProfileImage(
    profilPhoto: any,
    profilId: number
  ): Promise<{ link: string }> {
    return new Promise((resolve, reject) => {
      const fileBits = this.dataURItoBlob(profilPhoto);
      const imageFile = new File([fileBits], profilId.toString() + '.jpeg', {
        type: 'image/jpeg',
      });

      const postImage = new FormData();
      postImage.append('file', imageFile, profilId.toString() + '.jpeg');

      this.http
        .post(
          environment.apiURL +
            '/uploaddocument?actiontype=profilephoto&referedid=' +
            profilId +
            '&bucketname=b1development&directory=icibotV2/profiles/',
          postImage
        )
        .subscribe({
          next: (link: { link: string }) => {
            resolve(link);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }

  dataURItoBlob(dataURI): Blob {
    const byteCharacters = atob(
      dataURI.replace(/^data:image\/(png|jpeg|jpg);base64,/, '')
    );
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], {
      type: undefined,
    });
  }

  getProfilePhoto(profileId: number): Promise<string> {
    return new Promise((resolve, reject) => {
      this.http
        .get(environment.apiURL + '/profile_photo/' + profileId)
        .subscribe({
          next: (base64: string) => {
            resolve(base64);
          },
          error: (err) => {
            const error =
              err.error && err.error.message ? err.error.message : err.message;
            this.toaster.toastMachine(error, 'danger', 3000);
            reject(err);
          },
        });
    });
  }
}
